/**
 * Обертка над console.log для более удобного отображения "красивых" логов
 */
export class DebuggerConsole {
  constructor(private params: DebuggerConsoleParams) {}

  createGroup(name: string, value: unknown) {
    console.groupEnd()

    const log = [
      `%c ${this.params.badge} %c ${name} %c${value}`,
      `border-radius: 4px; background-color: ${this.params.badgeBgColor}; color: ${this.params.badgeColor};`,
      '',
      'font-weight: 400;'
    ]

    this.params.collapse ? console.groupCollapsed(...log) : console.group(...log)

    return this
  }

  log(...log: unknown[]) {
    console.log(...log)

    return this
  }

  endGroup() {
    console.groupEnd()

    return this
  }
}

type DebuggerConsoleParams = {
  badge: string
  badgeBgColor: string
  badgeColor: string
  collapse?: boolean
}
